import discountsReducer, {
  validateDiscountCode,
  resetDiscountValidation,
  resetDiscountValidationResponse,
} from './DiscountsApi';

import userReducer, {
  loginUser,
  resetLogin,
  resetLoginResponse,
} from './UserApi';

import countriesReducer, {
  fetchCountries,
  resetCountries,
  resetCountriesResponse,
} from './CountriesApi';

import productsReducer, {
  fetchProducts,
  resetProducts,
  resetProductsResponse,
} from './ProductsApi';

import pricingReducer, {
  calculatePricing,
  resetPricingCalculation,
  resetPricingCalculationResponse,
} from './PricingApi';

import contractsReducer, {
  createMainContract,
  createExtraContract,
  resetMainContract,
  resetMainContractResponse,
  resetExtraContract,
  resetExtraContractResponse,
} from './ContractsApi';

import ordersReducer, {
  confirmOrder,
  getOrder,
  resetOrderConfirmation,
  resetOrderConfirmationResponse,
  resetOrder,
  resetOrderResponse,
} from './OrdersApi';

import customersReducer, {
  getCustomer,
  resetCustomer,
  resetCustomerResponse,
} from './CustomersApi';

export const apiV2Reducers = {
  discounts: discountsReducer,
  user: userReducer,
  countries: countriesReducer,
  products: productsReducer,
  pricing: pricingReducer,
  contracts: contractsReducer,
  orders: ordersReducer,
  customers: customersReducer,
};

export {
  validateDiscountCode,
  resetDiscountValidation,
  resetDiscountValidationResponse,
  loginUser,
  resetLogin,
  resetLoginResponse,
  fetchCountries,
  resetCountries,
  resetCountriesResponse,
  fetchProducts,
  resetProducts,
  resetProductsResponse,
  calculatePricing,
  resetPricingCalculation,
  resetPricingCalculationResponse,
  createMainContract,
  createExtraContract,
  resetMainContract,
  resetMainContractResponse,
  resetExtraContract,
  resetExtraContractResponse,
  confirmOrder,
  getOrder,
  resetOrderConfirmation,
  resetOrderConfirmationResponse,
  resetOrder,
  resetOrderResponse,
  getCustomer,
  resetCustomer,
  resetCustomerResponse,
};

export * from './apiConfiguration'; 